import jwtDecode from 'jwt-decode';
import * as formService from './services/formService'
import * as authService from './services/authService'

export const REQUEST_FORMS = 'REQUEST_FORMS';
export const RECEIVE_FORMS = 'RECEIVE_FORMS';
export const REQUEST_FORM = 'REQUEST_FORM';
export const RECEIVE_FORM = 'RECEIVE_FORM';
export const UPDATE_DATA = 'UPDATE_DATA';
export const SAVE_ITEMS = 'SAVE_ITEMS';
export const FETCH_USERGUIDE = 'FETCH_USERGUIDE';
export const RECEIVE_USERGUIDE = "RECEIVE_USERGUIDE";
export const FETCH_CSV = 'FETCH_CSV';
export const RECEIVE_CSV = "RECEIVE_CSV";
export const FETCH_ITEMS = 'FETCH_ITEMS';
export const RECEIVE_ITEMS = 'RECEIVE_ITEMS';
export const SELECT_PAGE = 'SELECT_PAGE';
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const LOGIN_OK = 'LOGIN_OK';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';
export const SHOW_MODAL ='SHOW_MODAL';
export const REQUEST_SEND_TO_CUSTOMER = 'REQUEST_SEND_TO_CUSTOMER';
export const RECEIVE_SEND_TO_CUSTOMER = 'RECEIVE_SEND_TO_CUSTOMER';
export const REQUEST_SURVEY_IN_PROGRESS = 'REQUEST_SURVEY_IN_PROGRESS';
export const RECEIVE_SURVEY_IN_PROGRESS = 'RECEIVE_SURVEY_IN_PROGRESS';
export const REQUEST_SURVEY_SUBMITTED = 'REQUEST_SURVEY_SUBMITTED';
export const RECEIVE_SURVEY_SUBMITTED = 'RECEIVE_SURVEY_SUBMITTED';
export const REQUEST_SURVEY_REVIEWED = 'REQUEST_SURVEY_REVIEWED';
export const RECEIVE_SURVEY_REVIEWED = 'RECEIVE_SURVEY_REVIEWED';
export const REQUEST_CHANGE_CUSTOMER_EMAIL = 'REQUEST_CHANGE_CUSTOMER_EMAIL';
export const RECEIVE_CHANGE_CUSTOMER_EMAIL = 'RECEIVE_CHANGE_CUSTOMER_EMAIL';
export const REQUEST_CONVERSIONTABLE = 'REQUEST_CONVERSIONTABLE';
export const RECEIVE_CONVERSIONTABLE = 'RECEIVE_CONVERSIONTABLE';
export const EMAIL_EDIT_HIDE_MODAL = 'EMAIL_EDIT_HIDE_MODAL';
export const EMAIL_EDIT_SHOW_MODAL = 'EMAIL_EDIT_SHOW_MODAL';


function login() {
  return {
    type: REQUEST_LOGIN
  }
}

export function requestLogin(token) {
    return dispatch => {
      dispatch(login());
      return authService.fetchMyData(token)
        .then(json => {
          if (json.error) {
            console.log ("Login error:", json.error);
            dispatch(loginFailed(json.error))   
          } else {
            dispatch(loginOk(json))
          }
        })
    }
}

function loginOk(user) {
  console.log ("any login ok");
  return {
    type: LOGIN_OK,
    user: user
  }
}

function loginFailed(err) {
  return {
    type: LOGIN_FAILED,
    loginFailure: err
  }
}

export function storeToken(token, refreshToken) {
    sessionStorage.setItem('spasts_token', token);
    sessionStorage.setItem('refresh_token', refreshToken);

    return dispatch => {
        dispatch(login());
        return authService.fetchMyData(token)
            .then(json => {
                if (json.error === undefined) {
                    console.log ("store token login ok");
                    dispatch(loginOk(json))
                } else {
                    dispatch(loginFailed(json.error))
                }
            })
    }
}

export function logout() {
  sessionStorage.removeItem('spasts_token');
  sessionStorage.removeItem('refresh_token');
  return (dispatch) => {
    dispatch({
      type: LOGOUT,
    });
  }
}

export function showModal(show) {
  return (dispatch) => {
    dispatch({
      type: SHOW_MODAL,
      show
    });
  }
}

function saveFormAllPages(form) {
    const formId = form.formId;
    // const response = formService.saveFormAllPages(formId, form);
}


function saveForm(state, page) {
  if ((state.selectedPage !== 0) && (state.selectedPage !== state.form.pages.length+1)){
    //const selectedPage = page - 1;
    const selectedPage = state.selectedPage - 1;
    const formId = state.form.formId;
    const data = state.form.pages[selectedPage].formData;
    // formService.saveFormPage(formId, selectedPage, data);
  }
}

function fetchUserGuide() {
  return {
    type: FETCH_USERGUIDE
  }
}


function receiveUserGuide(json) {
  return {
    type: RECEIVE_USERGUIDE,
    data: json
  }
}

export function fetchFormUserGuide(formId) {
  return dispatch => {
    dispatch(fetchUserGuide());
    return formService.fetchUserGuide(formId)
      .then(json => dispatch(receiveUserGuide(json)))
  }
}

function fetchCSV() {
  return {
    type: FETCH_CSV
  }
}


function receiveCSV(json) {
  return {
    type: RECEIVE_CSV,
    data: json
  }
}

export function fetchFormCSV(formId) {
  return dispatch => {
    dispatch(fetchCSV());
    return formService.fetchCSV(formId)
      .then(json => dispatch(receiveCSV(json)))
  }
}

function fetchItems() {
  return {
    type: FETCH_ITEMS
  }
}


function receiveItems(json) {
  return {
    type: RECEIVE_ITEMS,
    fetchData: json
  }
}


export function fetchFormData(formId) {
  return dispatch => {
    dispatch(fetchItems());
    return formService.fetchFormData(formId)
      .then(json => dispatch(receiveItems(json)))
  }
}

export function saveItems(data, formId) {
  return (dispatch, getState) => {
       formService.saveFormData(formId, data);
    dispatch(
    {
      type: SAVE_ITEMS,
    })
  }
}

export function selectPage(page, form) {
  return (dispatch, getState) => {
    window.scrollTo(0, 230);
    // if (getState().form) {
    //   saveForm(getState(), page);
    // }
    /* mikkom! if (getState().form) {
      saveFormAllPages(form);
    } */
    dispatch(
    {
      type: SELECT_PAGE,
      page
    })
  }
}

function requestForms() {
  return {
    type: REQUEST_FORMS
  }
}

function receiveForms(json) {
  return {
    type: RECEIVE_FORMS,
    forms: json
  }
}

function requestConversionTable() {
  return {
    type: REQUEST_CONVERSIONTABLE
  }
}

function receiveConversionTable(json) {
  return {
    type: RECEIVE_CONVERSIONTABLE,
    forms: json
  }
}

export function fetchConversionTable() {
  return dispatch => {
    dispatch(requestConversionTable());
    return formService.fetchConversionTable()
      .then(json => dispatch(receiveConversionTable(json)))
  }
}

export function fetchForms() {
  return dispatch => {
    dispatch(requestForms());
    return formService.fetchForms(false)
      .then(json => {
          dispatch(receiveForms(json));
          dispatch(fetchFormsWithLinks())
      })
  }
}

function fetchFormsWithLinks() {
    return dispatch => {
        //dispatch(requestForms());
        return formService.fetchForms(true)
            .then(json => {
                dispatch(receiveForms(json));
            })
    }
}


function requestForm() {
  return {
    type: REQUEST_FORM
  }
}

function receiveForm(json) {
    // debugger;
  return {
    type: RECEIVE_FORM,
    data: json,
  }
}

export function fetchForm(formId) {
  return (dispatch, getState) => {
  /*  if (getState().form.pages.length > 0) {
      saveForm(getState());
    } */
    dispatch(requestForm());
    dispatch(fetchFormUserGuide(formId));
    dispatch(fetchFormCSV(formId));
    return formService.fetchForm(formId)
      .then(json => {dispatch(receiveForm(json))
                    dispatch(fetchFormData(formId))}
      )
  }
}

function shouldFetchForms(state) {
  const formsList = state.forms.formsList;
  if (formsList.length === 0 && !formsList.isFetching) {
    return true
  } else if (formsList.isFetching) {
    return false
  } else {
    return formsList.didInvalidate
  }
}

export function fetchFormsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchForms(getState())) {
      return dispatch(fetchForms())
    }
  }
}

export function updateData(page, data) {
  return {
    type: UPDATE_DATA,
    page: page,
    data: data
  }}





function requestSendToCustomer() {
    return {
        type: REQUEST_SEND_TO_CUSTOMER
    }
}

function receiveSendToCustomer(json) {
    return {
        type: RECEIVE_SEND_TO_CUSTOMER,
        data: json,
    }
}

export function surveyStateSendToCustomer(formId) {
    return (dispatch, getState) => {
        if (getState().form.pages.length > 0) {
         //   saveForm(getState());
        }

        dispatch(requestSendToCustomer());

        return formService.sendToCustomer(formId)
            .then(json => {
                dispatch(fetchForm(formId))
                dispatch(fetchForms())
                dispatch(receiveSendToCustomer(json))
            });
    }
}



function requestSurveyInProgress() {
    return {
        type: REQUEST_SURVEY_IN_PROGRESS
    }
}

function receiveSurveyInProgress(json) {
    return {
        type: RECEIVE_SURVEY_IN_PROGRESS,
        data: json,
    }
}

export function surveyStateInProgress(formId) {

    return (dispatch, getState) => {
        if (getState().form.pages.length > 0) {
        //    saveForm(getState());
        }
        dispatch(requestSurveyInProgress());

        formService.customerStartedSurvey(formId)
            .then(json => {
                dispatch(receiveSurveyInProgress(json))
           //     dispatch(fetchForm(formId))
           //     dispatch(fetchForms())

            });

    }
}


function requestSurveySubmitted() {
    return {
        type: REQUEST_SURVEY_SUBMITTED
    }
}

function receiveSurveySubmitted(json) {
    return {
        type: RECEIVE_SURVEY_SUBMITTED,
        data: json,
    }
}

export function surveyStateSubmitted(form, formId) {
    return (dispatch) => {
        // if (getState().form.pages.length > 0) {
        //     saveForm(getState());
        // }
        //saveFormAllPages(form);

        //dispatch(requestSurveySubmitted());

        return formService.surveySubmitted(form, formId)
            .then(json => {
                dispatch(receiveSurveySubmitted(json))
                dispatch(fetchForm(formId))
                dispatch(fetchForms())

            });
    }
}



function requestSurveyReviewed() {
    return {
        type: REQUEST_SURVEY_REVIEWED
    }
}

function receiveSurveyReviewed(json) {
    return {
        type: RECEIVE_SURVEY_REVIEWED,
        data: json,
    }
}

export function surveyStateReviewed(form, formId) {
    return (dispatch) => {
        //saveFormAllPages(form);
        //dispatch(requestSurveyReviewed());

        return formService.surveyReviewed(form, formId)
            .then(json => {
                dispatch(receiveSurveyReviewed(json))
                dispatch(fetchForm(formId))
                dispatch(fetchForms())

            });
    }
}



export function requestChangeCustomerEmail(formId) {
    return {
        type: EMAIL_EDIT_SHOW_MODAL,
        emailEditFormId: formId
    }
}


function requesHideEmailModal() {
    return {
        type: EMAIL_EDIT_HIDE_MODAL
    }
}

function receiveChangeCustomerEmail(json) {
    return {
        type: RECEIVE_CHANGE_CUSTOMER_EMAIL,
        data: json,
    }
}

export function changeCustomerEmail(formId, data, forms, formsList) {
    return (dispatch) => {
        // if (getState().form.pages.length > 0) {
        //     saveForm(getState());
        // }
        // dispatch(requestChangeCustomerEmail());
        let fList = formsList.slice();
        //debugger;
        dispatch(requestForms());
        fList.forEach(item => {
            if (formId === item['formId']) {
                item['formAssigneeEmail'] = data['formAssigneeEmail'];
            }
            return item;

        });
        //forms['formsList'] = formsList;
        dispatch(receiveForms(fList));
        return formService.changeCustomerEmail(formId, data)
            .then(json => {
                //dispatch(receiveChangeCustomerEmail(json))
                //dispatch(fetchForm(formId))
                dispatch(fetchForms())

            });
    }
}




// WEBPACK FOOTER //
// ./src/actions.js